var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg002Attached(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "34px",
    viewBox: "0 0 32 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cupload") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "8.45861517e-05 0.0826832298 31.8642484 0.0826832298 31.8642484 17.7347578 8.45861517e-05 17.7347578"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0.106732919 0.119711801 31.3552298 0.119711801 31.3552298 2.7826087 0.106732919 2.7826087"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tom",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cupload"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 14.806261)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9841789,17.7347578 L1.88002981,17.7347578 L0.0194583851,2.84919255 C-0.164193789,1.38017391 0.981247205,0.0826832298 2.46179379,0.0826832298 L29.4026137,0.0826832298 C30.8829615,0.0826832298 32.0286012,1.38017391 31.8449491,2.84919255 L29.9841789,17.7347578 Z",
    id: "Fill-1",
    fill: "#334A5E",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.0125019,32.4717516 L18.398887,17.3397267 C17.5056696,13.5991056 18.4495702,9.38385093 20.7476075,6.85028571 C21.2953839,6.24626087 21.5849739,5.55378882 21.5849739,4.84780124 C21.5849739,2.7284472 19.0494211,1.00402484 15.9323031,1.00402484 C12.8151851,1.00402484 10.279036,2.7284472 10.279036,4.84780124 C10.279036,5.55319255 10.5686261,6.2456646 11.1169988,6.85028571 C13.415036,9.38325466 14.3583404,13.5987081 13.465123,17.3397267 L9.85210435,32.4717516 L8.87560745,32.2388075 L12.4886261,17.1065839 C13.3083031,13.6736398 12.4584149,9.82290683 10.373446,7.52467081 C9.6551354,6.7322236 9.27530932,5.8066087 9.27530932,4.84780124 C9.27530932,2.17470807 12.261446,9.9378882e-05 15.9323031,9.9378882e-05 C19.6023652,9.9378882e-05 22.5887006,2.17470807 22.5887006,4.84780124 C22.5887006,5.80740373 22.2088745,6.73301863 21.490564,7.52467081 C19.4061913,9.82350311 18.5557068,13.674236 19.3753839,17.1065839 L22.9889988,32.2388075 L22.0125019,32.4717516 Z",
    id: "Fill-4",
    fill: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(0.198758, 30.905640)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3552298,1.44800994 C31.3552298,1.81650683 31.2041739,2.14863106 30.9688447,2.39012174 C30.7271553,2.63161242 30.3952298,2.78266832 30.0267329,2.78266832 L1.4413913,2.78266832 C0.704596273,2.78266832 0.106732919,2.18460621 0.106732919,1.44800994 C0.106732919,1.08587329 0.25778882,0.747587578 0.499279503,0.512059627 C0.740770186,0.270568944 1.07289441,0.119711801 1.4413913,0.119711801 L8.11368944,0.119711801 L8.11368944,0.838221118 L10.776646,0.838221118 L10.776646,0.119711801 L20.6914783,0.119711801 L20.6914783,0.838221118 L23.348472,0.838221118 L23.348472,0.119711801 L30.0267329,0.119711801 C30.763528,0.119711801 31.3552298,0.717376398 31.3552298,1.44800994",
    id: "Fill-6",
    fill: "#2C3B4E",
    mask: "url(#mask-4)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg002Attached);
export default __webpack_public_path__ + "static/media/002-attached.7e1d98b9899edcda02855428ea43d254.svg";
export { ForwardRef as ReactComponent };